///<reference path="../app.config.ts"/>
import {Component, OnInit} from '@angular/core';
import {HttpService} from '../services/http.service';
import {AppConfig} from '../app.config';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    public book = null;
    public homeBook = [];
    public AppConfig = AppConfig;
    public link_books: any;

    constructor(public http: HttpService) {
        this.getFeaturedBook();
        AppConfig.instance.getAllTextBlocks(textblocks => {
            this.homeBook = textblocks['home_books'];
        });
        AppConfig.instance.getConfig(link => {
            this.link_books = link['link_books'];
        });
    }

    ngOnInit() {
    }

    getFeaturedBook() {
        this.http.get(AppConfig.baseUrlApi + 'books/api_home_book').subscribe(response => {
            this.book = response.content;
        }, error => {
            console.log(error);
        });
    }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/home/home.component.ts